
export default {
    curso: {},
    cursos: []
}